module.exports = __webpack_public_path__ + "static/img/4.7589d71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/4.png
// module id = 0L8C
// module chunks = 0